export default class AberturaManualCommand {
  constructor(filaId) {
    this.filaId = filaId
    this.tipoSolicitacaoId = 0
    this.solicitanteId = 0
    this.solicitanteEmail = null
    this.titulo = ''
    this.conteudoTexto = ''
    this.anexos = []
  }
}
